import pathify from 'vuex-pathify';

pathify.options.mapping = 'simple';

export default pathify;
